import React from 'react';
import cn from 'classnames';
import Slider, { Settings } from 'react-slick';
import { useRenderers } from '../../../../renderProps';
import Cell from './Cell/Cell';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import { CompareTableGroups } from '../../../types';
import SlickSlider from '../../../../SlickSlider';

interface Props {
	compareTableGroups: CompareTableGroups;
	settings: Settings;
	sliders: Slider[];
	isFullFareConditions: boolean;
}

const Content: React.FC<Props> = ({ sliders, settings, compareTableGroups, isFullFareConditions }) => {
	const { t } = useTranslation('CompareFares');
	const { Content: css, FaresSlider: sliderCss } = useTheme('CompareFares');

	const { Cell: CellComponent = Cell } = useRenderers();

	return (
		<div className={css.col}>
			{compareTableGroups?.map(group => {
				return (
					<div className={css.col} key={group.title}>
						<div className={css.groupTitle}>{t(group.title)}</div>

						{group.rows.map(row => {
							return (
								<div
									key={row.title}
									className={cn(css.tableRow, {
										[css.tableRow_fullDescr]: isFullFareConditions
									})}
								>
									<div className={cn(css.title, sliderCss.title)}>{row.title}</div>
									<div className={cn(css.slider, sliderCss.slider)}>
										<SlickSlider ref={ref => sliders.push(ref)} {...settings}>
											{row.cells?.map((cell, index) => (
												<CellComponent
													key={cell?.title ?? index}
													cell={cell}
													isFullFareCondition={isFullFareConditions}
												/>
											))}
										</SlickSlider>
									</div>
								</div>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};

export default Content;
